






















































































































































































































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { SuperadminOptions } from '@core/interfaces/super-admin';
import FormProvider from '@shared/components/forms/form-provider.vue';
import CssEditor from '@shared/components/forms/inputs/css-editor/css-editor.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import moment from 'moment';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { superadmin_options } from '@/config/superadmin_options';

@Component({
  name: 'bpc-superadmin-options-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-css-editor': CssEditor,
    'bpc-switch': Switch,
  },
})
export default class SuperadminOptionsForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;
  // @Prop({ type: Object, default() {return {};}}) readonly myObjectProp: MyInterface;

  // DATA
  public formModel: SuperadminOptions = null;
  modelLoaded: boolean = false;

  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}

  // COMPUTED

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get fieldsConfig() {
    return superadmin_options;
  }

  get moduleFieldsConfig() {
    return Object.values(superadmin_options).filter((item: any) => {
      return item.fieldPath.includes('modules.') && !item.hideInModuleList;
    });
  }

  get creationDate() {
    if (this.formModel && this.formModel.created_at) {
      return moment(this.formModel.created_at).format('DD/MM/YYYY hh:mm');
    }
    return null;
  }

  get accountingIntegrations(): boolean {
    return this.formModel?.modules?.accounting_integrations_activated || false;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }
  // METHODS

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
    this.modelLoaded = true;
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  // WATCHERS
  @Watch('accountingIntegrations')
  onChangeAccountingIntegrations(value) {
    if (this.modelLoaded && !!value) {
      this.formModel.strict_accounting = true;
    }
  }
}
